function getUrlByParams(params = {}) {
  const url = new URL(window.location.origin+window.location.pathname);
  for (const [key, value] of Object.entries(params)) {
    if (value == null) {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, String(value));
    }
  }
  return url.toString();
}
export default getUrlByParams;